import React, { useEffect, useState, useCallback } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { ARCGIS_API, SIGNAGE_MEDIA } from '../../utils/constants';
import API from '../../utils/API';
import { timezome } from '../../utils/constants';
import DropdownSelect from './DropdownSelect';

const Calendar = ({
  setSuccess,
  closeModal,
  refreshData,
  data = [],
  calendarData = {},
  zone = "",
  setZone,
  setZoneData,
  updatePlaylistsMedia,
  markUnsavedChanges
}) => {

  const [timezone, setTimezone] = useState('Pacific/Pago_Pago');
  const [modalError, setModalError] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const timezoneOptions = Object.entries(timezome).map(([value, label]) => ({
    value,
    label
  }));
  /**
    * Reset modal
    */
  function resetModal() {
    setSubmitted(false);
    setModalError('');
    if (setZone)
      setZone('');
  }

  useEffect(() => {
    if (zone !== SIGNAGE_MEDIA.CREATE_SIGNAGE.WIDGET1&&zone !== SIGNAGE_MEDIA.CREATE_SIGNAGE.WIDGET2) return;
    if (calendarData && calendarData.content && calendarData.content.paramters) {
      const calendarParameters = calendarData.content.paramters;
      setTimezone(calendarParameters.timeZone || 'Pacific/Pago_Pago');
    }
  }, [calendarData, zone]);

  useEffect(() => {
    if (Object.keys(data).length > 0 && data.id) {
      const clockParameters = data.content.paramters;
      setTimezone(clockParameters.timeZone || 'Pacific/Pago_Pago');
    }
  }, [data]);

  useEffect(() => {
    const modalElement = document.getElementById('calendarModal');
    modalElement.addEventListener('hidden.bs.modal', resetModal);

    return () => {
      modalElement.removeEventListener('hidden.bs.modal', resetModal);
    };
  }, []);

  const handleAdd = async () => {
    try {
      if (zone) {
        setZoneData(prevCalendarData => {
          const newCalendarData = { ...prevCalendarData };
          newCalendarData[zone] = {
            zone: zone,
            content: {
              category: SIGNAGE_MEDIA.MEDIA_CATEGORY.WIDGET,
              subcategory: SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.CALENDAR,
              type: SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.CALENDAR,
              name: SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.CALENDAR,
              paramters: {
                timeZone: timezone
              }
            }
          };
          return newCalendarData;
        });
      } else {
        const formData = {
          category: SIGNAGE_MEDIA.MEDIA_CATEGORY.WIDGET,
          subcategory: SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.CALENDAR,
          type: SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.CALENDAR,
          name: "",
          content: {
            paramters: {
              timeZone: timezone
            }
          }
        };
        if (Object.keys(data).length > 0 && data.id) {
          formData.id = data.id;
          await API.updateMedia(formData);
          updatePlaylistsMedia(formData);
          setSuccess(<FormattedMessage id="EDIT_CALENDAR_SUCCESS" />);
        } else {
          await API.addMedia(formData);
          setSuccess(<FormattedMessage id="ADD_CALENDAR_SUCCESS" />);
        }
        markUnsavedChanges && markUnsavedChanges();
        refreshData();
      }
      closeModal("calendarModal");
    } catch (err) {
      const errorId = Object.keys(data).length > 0 && data.id ? "EDIT_CALENDAR_FAILED" : "ADD_CALENDAR_FAILED";
      setModalError(<FormattedMessage id={errorId} values={{ errorMsg: <b>{err.message}</b> }} />);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleAdd();
  };

  return (
    <div className='modal modal-mse fade' id='calendarModal' tabIndex='-1' aria-labelledby='calendarModalLabel' aria-hidden='true'>
      <div className='modal-dialog modal-dialog-centered'>
        <div className='modal-content modal-mes-content' style={{ overflow: 'visible' }}>
          <div className='modal-header modal-mes-header' style={{ backgroundColor: '#347BFA' }}>
            <h5 className='modal-title modal-mes-title'><FormattedMessage id='CALENDAR' /></h5>
            <button id="closeModal" type='button' className='btn-close' data-bs-dismiss='modal' aria-label='Close'></button>
          </div>
          <div className='modal-body' style={{ overflow: 'visible' }}>
            <form onSubmit={handleSubmit}>
              <div className='row'>
                <div className="mb-3 col-12">
                  <label className="font-weight-600 font-size-14 mb-2"><FormattedMessage id="TIMEZONE" defaultMessage="Timezone" />:</label>
                  <DropdownSelect
                    options={timezoneOptions}
                    value={timezone}
                    onChange={setTimezone}
                  />
                </div>
              </div>
            </form>
          </div>
          <div className='modal-footer modal-mes-footer d-flex align-items-center'>
            <button id="cancelBtn" type='button' className='btn btn-outline-secondary me-3' data-bs-dismiss='modal'>
              <FormattedMessage id='CANCEL' />
            </button>
            <button id="saveGroupBtn" className='btn btn-primary but-darkblue' type='button' onClick={handleSubmit}>
              <FormattedMessage id='ADD_CALENDAR' />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Calendar;
